<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">我的教学</div>
    </div>
    <div class="center">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="课程管理" name="first">
          <div class="course">
            <el-row :gutter="10">
              <el-col :span="6" v-for="(item,index) in relevant" :key="index">
                <div class="grid-content bg-purple">
                  <router-link to="/repositories/rescoursedet">
                    <div class="itemnewImg">
                      <img src="../../assets/img/relevantItem.png" alt />
                    </div>
                  </router-link>
                  <div class="itemTit">新突破大学英语综合教材</div>
                  <div class="user">
                    编辑
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="addImg">
              <img src="../../assets/img/addcourse.png" alt />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="素材管理" name="second">课程管理1</el-tab-pane>
        <el-tab-pane label="资源包管理" name="third">课程管理</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      relevant: [
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 }
      ]
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 30px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 4px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
.course {
}
.itemnewImg {
  margin-top: 10px;
  width: 100%;
  height: 117px;
  img {
    height: 100%;
    width: 100%;
  }
}
.addImg {
  margin-top: 10px;
  width: 185px;
  height: 117px;
  margin-bottom: 60px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: rgba(181, 14, 5, 1);
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    color: rgba(181, 14, 5, 1);
  }
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';
</style>